import axios from 'axios';

const apiLogin =  axios.create({
    baseURL: '/api/',
});

export default apiLogin;
